var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag"},[_c('span',[_vm._v(_vm._s(_vm.tag))]),_vm._v(" "),(_vm.isRemovable)?_c('i',{staticClass:"fa fa-remove tag-remove",on:{"click":function($event){return _vm.$emit('remove')}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }